import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["beforeNext", "tourKey", "stepKey", "children", "use", "size", "useInStepKey", "navigationCallbackPath"];
import { useContext, useRef } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import TourContext from '../contexts/TourContext';
import getNextStep from '../lib/getNextStep';
import { DONE } from '../constants/TourStates';
import handleCallback from '../lib/handleCallback';
import { ONBOARDING_COLOR } from '../constants/colors';
import { TourButtonLabel } from '../constants/styles';
import { hasRedesignGate } from '../utils/redesignGate';
import UITourNextButtonLegacy from './UITourNextButton.legacy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function renderDefaultContent(tour) {
  const isFinish = getNextStep(tour) === DONE;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "100",
    children: [isFinish && /*#__PURE__*/_jsx(SuccessIcon, {
      size: "100",
      color: ONBOARDING_COLOR
    }), /*#__PURE__*/_jsx(TourButtonLabel, {
      children: isFinish ? I18n.text('shepherd-react.finish') : I18n.text('shepherd-react.next')
    }), !isFinish && /*#__PURE__*/_jsx(RightIcon, {
      size: "100",
      color: ONBOARDING_COLOR
    })]
  });
}
const isTourStepMatched = (tourContext, stepKey) => {
  // If stepKey is empty, consider as matched
  if (!stepKey) {
    return true;
  }
  const currentStepKey = tourContext.getStep();
  return currentStepKey === stepKey;
};
const UITourNextButtonModern = props => {
  const {
    tour
  } = useContext(TourContext);
  const {
      beforeNext = emptyFunction,
      tourKey,
      stepKey,
      children = renderDefaultContent(tour),
      use = 'primary-on-fill',
      size = 'small',
      useInStepKey,
      navigationCallbackPath
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    getTour,
    getStep
  } = tour;
  const isHandlingClick = useRef(false);
  const handleClick = event => {
    // Skip click handler if:
    //   1. tour handler is executing
    //   2. Or current tour step are not matched with given props
    if (isHandlingClick.current || !isTourStepMatched(tour, useInStepKey)) {
      return null;
    }
    isHandlingClick.current = true;
    if (props.onClick) {
      props.onClick(event);
    }
    try {
      return handleCallback(beforeNext, () => {
        tour.next(stepKey);
        isHandlingClick.current = false;
        if (navigationCallbackPath && tour.navigationCallback) {
          tour.navigationCallback(navigationCallbackPath);
        }
      }, {
        tourKey: tourKey || getTour(),
        stepKey: stepKey || getStep()
      });
    } catch (error) {
      isHandlingClick.current = false;
      throw error;
    }
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({
    use: use,
    size: size
  }, buttonProps, {
    onClick: handleClick,
    children: children
  }));
};
const UITourNextButton = props => {
  if (hasRedesignGate()) {
    return /*#__PURE__*/_jsx(UITourNextButtonModern, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(UITourNextButtonLegacy, Object.assign({}, props));
};
export { UITourNextButtonModern };
export default UITourNextButton;